import { STUDENT_FIELD_TYPES } from './studentProfileFields'

export const PROFILE_FIELD_ENTITY_TYPES = {
  STUDENT: 'student',
  PARENT: 'parent',
  EMPLOYEE: 'employee',
}

const IDENTITY_PROFILE_FIELD_IDS = ['email', 'phone', 'login']

/**
 * @param {any[]} fields
 * @param {any} field
 * @param {(field: any) => boolean} isActive
 */
export const isLastActiveIdentityProfileField = (
  fields = [],
  field = {},
  isActive = () => false,
) =>
  IDENTITY_PROFILE_FIELD_IDS.includes(field.id) &&
  isActive(field) &&
  !fields.some(
    (item) =>
      item.id !== field.id &&
      IDENTITY_PROFILE_FIELD_IDS.includes(item.id) &&
      isActive(item),
  )

export const isPersistedProfileField = (field) =>
  Number.isFinite(Number(field?.id))

export const getProfileFieldValueKey = (field) =>
  String(field?.id ?? field?.name ?? '')

export const getProfileFieldValue = (values = {}, field = {}) => {
  const idKey = getProfileFieldValueKey(field)

  return values?.[idKey] ?? values?.[field?.name]
}

export const setProfileFieldValue = (values = {}, field = {}, value) => ({
  ...values,
  [getProfileFieldValueKey(field)]: value,
})

export const getProfileFieldValuesPayload = (fields = [], values = {}) =>
  fields.reduce((acc, field) => {
    if (!isPersistedProfileField(field)) return acc

    acc[getProfileFieldValueKey(field)] = getProfileFieldValue(values, field) ?? ''

    return acc
  }, {})

export const getProfileFieldApiPayload = (field = {}, entityType) => ({
  entity_type: entityType,
  name: String(field.name ?? '').trim(),
  label: String(field.label ?? '').trim(),
  type: field.type,
  value_options:
    field.type === STUDENT_FIELD_TYPES.SELECT
      ? field.value_options ?? []
      : null,
  is_active: Boolean(field.is_active),
  is_required: Boolean(field.required ?? field.is_required),
  sorting: Number(field.sorting) || 1,
  profile_visible: Boolean(field.profile_visible),
  profile_editable: Boolean(field.profile_visible && field.profile_editable),
  employee_visible: Boolean(field.employee_visible),
  sales_manager_visible: Boolean(field.sales_manager_visible),
  teacher_visible: Boolean(field.teacher_visible),
})

export const getProfileFieldUpdatePayload = (field = {}) => ({
  label: String(field.label ?? '').trim(),
  value_options:
    field.type === STUDENT_FIELD_TYPES.SELECT
      ? field.value_options ?? []
      : null,
  is_active: Boolean(field.is_active),
  is_required: Boolean(field.required ?? field.is_required),
  sorting: Number(field.sorting) || 1,
  profile_visible: Boolean(field.profile_visible),
  profile_editable: Boolean(field.profile_visible && field.profile_editable),
  employee_visible: Boolean(field.employee_visible),
  sales_manager_visible: Boolean(field.sales_manager_visible),
  teacher_visible: Boolean(field.teacher_visible),
})

export const getProfileFieldsResponseData = (response) =>
  Array.isArray(response?.data?.data) ? response.data.data : []

export const getProfileFieldValuesResponseData = (response) =>
  response?.data?.data &&
  typeof response.data.data === 'object' &&
  !Array.isArray(response.data.data)
    ? response.data.data
    : {}
